import {useEffect, useState} from "react";

export default function ProductSpecsArray({pageData}) {
    const [specOpen, setSpecOpen] = useState(true);
    const [showAllOptions, setShowAllOptions] = useState(false);
    const toggleOptions = () => {
        setSpecOpen(!specOpen)
        setShowAllOptions((prevShowAll) => !prevShowAll);
    };

    const setupData = () => {
        const allItems = [];

        if (pageData?.greenProperties?.plantenperm2) {
            allItems.push({
                label: 'Planten per m2',
                value: pageData?.greenProperties?.plantenperm2
            });
        }

        if (pageData?.greenProperties?.kleur) {
            allItems.push({
                label: 'Kleur',
                value: pageData?.greenProperties?.kleur
            });
        }

        if (pageData?.greenProperties?.hoogte) {
            allItems.push({
                label: 'Hoogte',
                value: pageData?.greenProperties?.hoogte
            });
        }

        if (pageData?.greenProperties?.standplaats) {
            allItems.push({
                label: 'Standplaats',
                value: pageData?.greenProperties?.standplaats
            });
        }

        if (pageData?.greenProperties?.bloei_aanvang) {
            allItems.push({
                label: 'Bloei aanvang',
                value: pageData?.greenProperties?.bloei_aanvang
            });
        }

        if (pageData?.greenProperties?.bloei_eind) {
            allItems.push({
                label: 'Bloei eind',
                value: pageData?.greenProperties?.bloei_eind
            });
        }

        if (pageData?.greenProperties?.blad_1) {
            allItems.push({
                label: 'Blad',
                value: pageData?.greenProperties?.blad_1,
                sort: 1
            });
        }

        if (pageData?.greenProperties?.bloemen) {
            allItems.push({
                label: 'Bloemen',
                value: pageData?.greenProperties?.bloemen
            });
        }

        if (pageData?.greenProperties?.grondsoort) {
            allItems.push({
                label: 'Grondsoort',
                value: pageData?.greenProperties?.grondsoort
            });
        }


        if (pageData?.greenProperties?.toepassing) {
            allItems.push({
                label: 'Toepassing',
                value: pageData?.greenProperties?.toepassing
            });
        }

        if (pageData?.greenProperties?.oorsprong) {
            allItems.push({
                label: 'Oorsprong',
                value: pageData?.greenProperties?.oorsprong
            });
        }

        if (pageData?.greenProperties?.giftigheid) {
            allItems.push({
                label: 'Giftigheid',
                value: pageData?.greenProperties?.giftigheid
            });
        }

        if (pageData?.greenProperties?.groenverliezend) {
            allItems.push({
                label: 'Groenverliezend',
                value: pageData?.greenProperties?.groenverliezend
            });
        }

        if (pageData?.greenProperties?.vruchten_1) {
            allItems.push({
                label: 'Vruchten',
                value: pageData?.greenProperties?.vruchten_1
            });
        }

        if (pageData?.greenProperties?.bestandheid) {
            allItems.push({
                label: 'Bestandheid',
                value: pageData?.greenProperties?.bestandheid
            });
        }

        if (pageData?.greenProperties?.stekels) {
            allItems.push({
                label: 'Stekels',
                value: pageData?.greenProperties?.stekels
            });
        }

        if (pageData?.greenProperties?.schors_en_takken) {
            allItems.push({
                label: 'Schors en takken',
                value: pageData?.greenProperties?.schors_en_takken
            });
        }

        if (pageData?.greenProperties?.faunaboom) {
            allItems.push({
                label: 'Faunaboom',
                value: pageData?.greenProperties?.faunaboom
            });
        }

        if (pageData?.greenProperties?.verharding) {
            allItems.push({
                label: 'Verharding',
                value: pageData?.greenProperties?.verharding
            });
        }

        if (pageData?.greenProperties?.winterhardheid) {
            allItems.push({
                label: 'Winterhardheid',
                value: pageData?.greenProperties?.winterhardheid
            });
        }

        if (pageData?.greenProperties?.bodemvochtigheid) {
            allItems.push({
                label: 'Bodemvochtigheid',
                value: pageData?.greenProperties?.bodemvochtigheid
            });
        }

        if (pageData?.greenProperties?.typevorm) {
            allItems.push({
                label: 'Typevorm',
                value: pageData?.greenProperties?.typevorm
            });
        }

        if (pageData?.greenProperties?.hout_steel) {
            allItems.push({
                label: 'Houtsteel',
                value: pageData?.greenProperties?.hout_steel
            });
        }

        if (pageData?.greenProperties?.steunen_leiden) {
            allItems.push({
                label: 'Steunen leiden',
                value: pageData?.greenProperties?.steunen_leiden
            });
        }

        if (pageData?.greenProperties?.kroon) {
            allItems.push({
                label: 'Kroon',
                value: pageData?.greenProperties?.kroon
            });
        }

        if (pageData?.greenProperties?.synoniemen) {
            allItems.push({
                label: 'Synoniemen',
                value: pageData?.greenProperties?.synoniemen
            });
        }



        return allItems;
    }

    const [items, setItems] = useState(setupData());

    return (
        <table className={'w-full'}>
            <thead className={'cursor-pointer'} onClick={() => {
                toggleOptions()
            }
            }>
            <tr className={'bg-olaf-green-500'}>
                <th className={'text-white text-left p-2 w-1/2'}><p>Omschrijving</p></th>
                <th className={'text-white text-left w-1/2'}><p>Waarde</p></th>
                <th className={'text-white text-right'}>
                    <img
                        src="/assets/icon/chevron-down.svg"
                        className={`ml-auto mr-4 transition duration-200 ease-in-out transform lg:brightness-0 lg:invert object-cover ${
                            !specOpen && 'rotate-180'
                        }`}
                        alt=""
                    />
                </th>
            </tr>
            </thead>
            <tbody className={``}>

            {items.map((property, i) => {
                if (i > 4) {
                    return;
                }
                return (<tr key={i} className={'odd:bg-white even:bg-olaf-green-500/25'}>
                    <td><p className={'font-semibold p-2'}>{property.label}</p></td>
                    <td colSpan={2}><p className={'lowercase first-letter:uppercase'}>{property.value}</p></td>
                </tr>);
            })}
            {!showAllOptions && <>
                <tr className={'odd:bg-white even:bg-olaf-green-500/25 cursor-pointer'}
                    onClick={() => {
                        toggleOptions()
                    }}>
                    <td><p className={'font-semibold p-2'}>Klik hier om meer te laden...</p></td>
                    <td colSpan={2}><p></p></td>
                </tr>
            </>}
                {showAllOptions && items?.length > 5 && <>
                    {items.map((property, i) => {
                        if (i < 5) {
                            return;
                        }
                        return (<tr key={i} className={'odd:bg-white even:bg-olaf-green-500/25'}>
                            <td><p className={'font-semibold p-2'}>{property.label}</p></td>
                            <td colSpan={2}><p className={'lowercase first-letter:uppercase'}>{property.value}</p></td>
                        </tr>);
                    })}
                    <tr className={'odd:bg-white even:bg-olaf-green-500/25 cursor-pointer'}
                        onClick={() => {
                            toggleOptions()
                        }}>
                        <td><p className={'font-semibold p-2'}>Klik hier om minder te tonen...</p>
                        </td>
                        <td colSpan={2}><p></p></td>
                    </tr>
            </>}
            </tbody>
        </table>
    )

}